import { forEach, get } from 'lodash';

export default function Cart(response) {
  if (!response.result) {
    return null;
  }

  const orderMapping = {
    sessionkey: 'SessionKey',
    order_no: 'Id',
    appeal_no: 'Appeal.Id',
    source_no: 'Source.Id',
    customer_no: 'Constituent.Id',
    solicitor: 'Solicitor',
    MOS: 'ModeOfSale.Id',
    order_dt: 'OrderDateTime',
    order_total: 'CartAmount',
    order_value: 'CartAmount',
    db_status: 'DbStatus',
    amt_to_charge: 'BalanceToCharge',
    first_seat_added_dt: 'FirstSeatAddedDateTime',
    amt_paid_to_dt: 'AmountPaidPreviously',
    amt_paid_now: 'AmountPaidNow',
    balance_to_charge: 'BalanceToCharge',
    subTotal: 'SubTotal',
    HandlingCharges: 'FeesAmount',
  };

  const lineItemMapping = {
    li_seq_no: 'Id',
    li_no: 'Id',
    order_no: null,
    pkg_no: 0,
    perf_no: 'Performance.Id',
    priority: null,
    zone_no: null,
    alt_upgrd_ind: 'AlternateUpgrade',
    primary_ind: 'Primary',
    perf_code: 'Performance.Code',
    perf_dt: 'Performance.PerformanceDateTime',
    perf_desc: 'Performance.Description',
    facility_desc: 'Performance.Facility.Description',
    db_status: 'DbStatus',
    zmap_no: 'Performance.ZoneMap.Id',
    prod_type: 'Performance.Type.Id',
    prod_type_desc: 'Performance.Type.Description',
    category: null,
    assoc_customer_no: null,
    season_no: 'Performance.Season.Id',
    season_desc: 'Performance.Season.Description',
    ga_ind: null,
    facil_no: 'Performance.Facility.Id',
    line_source_no: 'Source.Id',
  };

  const sublineItemMapping = {
    sli_no: 'SubLineItems[_I_].Id',
    li_seq_no: 'Id',
    due_amt: 'SubLineItems[_I_].DueAmount',
    paid_amt: 'SubLineItems[_I_].PaidAmount',
    price_type: 'SubLineItems[_I_].PriceType.Id',
    seat_no: 'SubLineItems[_I_].Seat.Id',
    perf_no: 'Performance.Id',
    pkg_no: 0,
    zone_no: 'SubLineItems[_I_].Zone.Id',
    order_no: null,
    seat_row: 'SubLineItems[_I_].Seat.Row',
    seat_num: 'SubLineItems[_I_].Seat.Number',
    zone_desc: 'SubLineItems[_I_].Zone.Description',
    section_desc: 'SubLineItems[_I_].Seat.Section.Description',
    section_short_desc: 'SubLineItems[_I_].Seat.Section.ShortDescription',
    section_print_desc: 'SubLineItems[_I_].Seat.Section.PrintDescription',
    db_status: 'SubLineItems[_I_].DbStatus',
    prod_season_no: 'Performance.ProductionSeason.Id',
    facility_no: 'Performance.Facility.Id',
    seat_type: null,
    seat_type_desc: null,
  };

  const packageLineItemMapping = {
    li_seq_no: 'Id',
    li_no: 'LineItemGroupId',
    order_no: null,
    pkg_no: 'Package.Id',
    super_pkg_no: 'SuperPackageId',
    perf_no: 'Performance.Id',
    priority: null,
    zone_no: null,
    alt_upgrd_ind: 'AlternateUpgrade',
    pkg_li_no: 'PackageLineItemId',
    primary_ind: 'Primary',
    perf_desc: 'Performance.Description',
    pkg_code: 'Package.Code',
    pkg_desc: 'Package.Description',
    facility_desc: 'Performance.Facility.Description',
    db_status: 'DbStatus',
    notes: 'SpecialRequest.Notes',
    zmap_no: 'Performance.ZoneMap.Id',
    text1: null,
    text2: null,
    text3: null,
    text4: null,
    perf_group_no: null,
    prod_type: 'Performance.Type.Id',
    prod_type_desc: 'Performance.Type.Description',
    fixed_seat_ind: 'Package.FixedPackage',
    super_pkg_ind: 'Package.SuperPackage',
    flex_ind: 'Package.NFSPackage',
    category: null,
    assoc_customer_no: null,
    season_no: 'Package.Season.Id',
    season_desc: 'Package.Season.Description',
    ga_ind: null,
    facil_no: 'Performance.Facility.Id',
    line_source_no: 'Source.Id',
  };

  const packageSublineItemMapping = {
    sli_no: 'SubLineItems[_I_].Id',
    li_seq_no: 'Id',
    due_amt: 'SubLineItems[_I_].DueAmount',
    paid_amt: 'SubLineItems[_I_].PaidAmount',
    price_type: 'SubLineItems[_I_].PriceType.Id',
    seat_no: 'SubLineItems[_I_].Seat.Id',
    perf_no: 'Performance.Id',
    pkg_no: 'Package.Id',
    zone_no: 'SubLineItems[_I_].Zone.Id',
    order_no: null,
    db_status: 'SubLineItems[_I_].DbStatus',
    prod_season_no: 'Performance.ProductionSeason.Id',
    facility_no: 'Performance.Facility.Id',
    seat_type: null,
    seat_type_desc: null,
  };

  const mapped = {
    Order: {},
    LineItem: [],
    SubLineItem: [],
    PackageLineItem: [],
    PackageSubLineItem: [],
    // We don't use these
    SubLineItemFee: [],
    Fee: [],
    Contribution: [],
    PriceType: [],
    Payment: [],
  };

  forEach(orderMapping, (property, key) => {
    mapped.Order[key] = get(response.result, property, null);
  });

  if (!response.result.Products) {
    return mapped;
  }

  const performanceProducts = response.result.Products.filter(product => {
    return !!product.Performance;
  });

  performanceProducts.forEach(product => {
    const lineItem = {};

    forEach(lineItemMapping, (property, key) => {
      if (key === 'pkg_no') {
        lineItem[key] = property;
      } else {
        lineItem[key] = get(product.Performance.LineItem, property, null);
      }
    });

    mapped.LineItem.push(lineItem);

    for (let i = 0; i < product.Performance.LineItem.SubLineItems.length; i++) {
      const sublineItem = {};

      forEach(sublineItemMapping, (property, key) => {
        if (!property || key === 'pkg_no') {
          sublineItem[key] = property;
        } else {
          sublineItem[key] = get(product.Performance.LineItem, property.replace('_I_', i), null);
        }
      });

      mapped.SubLineItem.push(sublineItem);
    }
  });

  const packageProducts = response.result.Products.filter(product => {
    return !!product.Package;
  });

  packageProducts.forEach(product => {
    product.Package.LineItems.forEach(item => {
      const packageLineItem = {};

      forEach(packageLineItemMapping, (property, key) => {
        if (!property) {
          packageLineItem[key] = property;
        } else {
          packageLineItem[key] = get(item, property, null);
        }
      });

      mapped.PackageLineItem.push(packageLineItem);

      for (let i = 0; i < (item.SubLineItems || []).length; i++) {
        const packageSublineItem = {};

        forEach(packageSublineItemMapping, (property, key) => {
          if (!property) {
            packageSublineItem[key] = property;
          } else {
            packageSublineItem[key] = get(item, property.replace('_I_', i), null);
          }
        });

        mapped.PackageSubLineItem.push(packageSublineItem);
      }
    });
  });

  return mapped;
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/tessitura/REST/maps/Cart.js